export default "__VITE_ASSET__Do1QV6Zm__"